import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "download",
      description: "a元素download字段",
      type: "String"
    },
    {
      prop: "href",
      description: "a元素href字段",
      type: "String"
    }
  ],
  events: [],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
